import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Caixa } from 'src/app/admihair/api/dto/caixa';
import { CaixaService } from 'src/app/admihair/service/caixa.service';
import { ConfirmationService, LazyLoadEvent, SelectItem } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { Comanda } from 'src/app/admihair/api/dto/comanda';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { ComandaService } from 'src/app/admihair/service/comanda.service';
import { Constantes } from 'src/app/admihair/util/constantes';
import { TrasnferenciaContaService } from 'src/app/admihair/service/transferencia-conta.service';
import { TransferenciaConta } from 'src/app/admihair/api/dto/transferencia-conta';
import { SaidaCaixa } from 'src/app/admihair/api/dto/saida-caixa';
import { SaidaCaixaService } from 'src/app/admihair/service/saida-caixa.service';
import { TipoPagamentoService } from 'src/app/admihair/service/tipo-pagamento.service';
import { TipoPagamento } from 'src/app/admihair/api/dto/tipo-pagamento';
import { PagamentoDespesa } from 'src/app/admihair/api/dto/pagamento-despesa';
import { PagamentoDespesaService } from 'src/app/admihair/service/pagamento-despesa.service';
import { CompetenciaDTO } from 'src/app/admihair/api/dto/competencia-dto';

@Component({
  selector: 'app-caixa-listar',
  templateUrl: './caixa-listar.component.html',
  styleUrls: ['./caixa-listar.component.scss']
})
export class CaixaListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loadingTable: boolean = true;
  listaCaixasAbertos: SelectItem[] = [];
  caixaSelecionado?: Caixa;
  listaComandas: Comanda[] = [];
  itensPaginados?: Paginador<Comanda>;
  numeroPagina: number = 0;
  ordenacao?: string;
  inputBusca: string = '';
  listaSitucoesStatus: string[] = ['TODAS','ABERTA', 'FECHADA'];
  statusComandaSelecionado: string = 'TODAS';
  dataAtual?: string;

  exibirDialogSangria: boolean = false;
  dataSangria?: Date;
  valorSangria?: number;
  loadingSangria: boolean = false;

  exibirDialogSangriaListar: boolean = false;
  listaSangrias: TransferenciaConta[] = [];
  loadingSangriaListar: boolean = true;

  tiposPagamentoSangriaOrigem: TipoPagamento[] = [];
  tipoPagamentoOrigemSelecionado?: TipoPagamento;
  tiposPagamentoSangriaDestino: TipoPagamento[] = [];
  tipoPagamentoDestinoSelecionado?: TipoPagamento;

  exibirDialogSaida: boolean = false;
  loadingSaida: boolean = false;
  listaSaidasCaixa: SaidaCaixa[] = [];

  exibirDialogPagamentos: boolean = false;
  loadingPagamentos: boolean = false;
  listaDespesasEmAberto: PagamentoDespesa[] = [];
  etapaPagamento: boolean = false;
  despesaSelecionada?: PagamentoDespesa;
  listaTipoPagamentoDespesa: TipoPagamento[] = [];
  tipoPagamentoDespesaSelecionado?: TipoPagamento;
  progressoRequisicaoPagamento: boolean = false;

  filtroMesesPagamentos: SelectItem[] = [];
  filtroMesSelecionado?: CompetenciaDTO;

  exibirDialogPagamentoListar: boolean = false;
  loadingPagamentosListar: boolean = true;
  listaDespesasPagas: PagamentoDespesa[] = [];
  
  exibirDialogSaidaInserir: boolean = false;
  listaTipoPagamentoSaida: TipoPagamento[] = [];
  tipoPagamentoSaidaSelecionado?: TipoPagamento;
  identificacaoSaida?: string;
  valorSaida?: number;
  loadingSaidaInserir: boolean = false;
  

  constructor(private caixaService: CaixaService,
    private comandaService: ComandaService,
    private transferenciaContaService: TrasnferenciaContaService,
    private saidaCaixaService: SaidaCaixaService,
    private tipoPagamentoService: TipoPagamentoService,
    private pagamentoDespesaService: PagamentoDespesaService,
    private confirmationService: ConfirmationService,
    private datePipe: DatePipe,
    erroService: ErroService,
    storageService: UtilStorageService,
    activatedRoute: ActivatedRoute,
    router: Router) {
    super(erroService, storageService, router, activatedRoute)
   }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.verificarPermissões();
    this.obterDataAtualString();
    if (this.permissaoListar) {
      this.carregarCaixasAbertos();
    }
  }

  verificarPermissões() {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_CAIXA');
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_COMANDA');
    this.permissaoDetalhar = this.verificarPermissao('PERM_DETALHAR_COMANDA');
    this.permissaoEditar = this.verificarPermissao('PERM_EDITAR_COMANDA');
  }

  obterDataAtualString() {
    const hoje = new Date();
    this.dataAtual = this.datePipe.transform(hoje, 'yyyy-MM-dd') ?? '';
  }

  carregarCaixasAbertos() {
    this.caixaSelecionado = this.getCaixaSelecionado();
    this.caixaService.listarAbertosPorEmpresa(this.getEmpresa().id).subscribe({
      next: (data: Caixa[]) => {
        this.processarCaixasAbertos(data);
        this.setExibirSpinnerPrincipal(false);
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    });
  }

  processarCaixasAbertos(caixas: Caixa[]) {
    caixas.map(caixa => {
      this.listaCaixasAbertos.push({label: this.datePipe.transform(caixa.dataCaixa,
        'dd/MM/yyyy') ?? '', value: caixa})

    });
    if(this.caixaSelecionado) {
      const caixaDoDia = this.listaCaixasAbertos
        .find(cx => cx.value.dataCaixa === this.dataAtual);
      
      if(!caixaDoDia) {
        this.listaCaixasAbertos
          .unshift({label: 'Não há caixa do dia', value: undefined});
      }
    }
    if(!this.caixaSelecionado) {
      const caixaDoDia = this.listaCaixasAbertos
        .find(cx => cx.value.dataCaixa === this.dataAtual);
      
      this.caixaSelecionado = caixaDoDia ? caixaDoDia.value : undefined;

      if(!caixaDoDia) {
        this.listaCaixasAbertos
          .unshift({label: 'Não há caixa do dia', value: undefined});
      }

      this.definirCaixaSelecionado();
    }
  }

  onLazyLoad(event: LazyLoadEvent) {
    if(event.first !== undefined && event.rows !== undefined) {
      if (event.first === 0 && event.rows === 0) {
        this.numeroPagina = 0;
      } else {
        this.numeroPagina = event.first / event.rows;
      }
    }
    this.definirOrdenacao(event.sortField, event.sortOrder);
    this.listarComandas();
  }

  definirCaixaSelecionado() {
    if(this.caixaSelecionado) {
      this.setCaixaSelecionado(this.caixaSelecionado);
      this.listarComandas();
    } else {
      this.limparCaixaSelecionado();
      this.listaComandas = [];
      this.itensPaginados = undefined;
    }
  }

  alterarCaixa() {
    this.definirCaixaSelecionado();
  }


  listarComandas() {
    this.loadingTable = true;
    if(this.caixaSelecionado) {
      const data = this.caixaSelecionado.dataCaixa;
      this.comandaService.listarComandasPorEmpresaCaixaEStatus(this.getEmpresa().id, data,
        this.statusComandaSelecionado, this.numeroPagina, Constantes.QTD_ITENS_10_POR_PAGINA,
        this.ordenacao, this.inputBusca).subscribe({
          next: (data: Paginador<Comanda>) => {
            this.listaComandas = data.content;
            this.itensPaginados = data;
            this.loadingTable = false;
          },
          error: (err: any) => {
            this.loadingTable = false;
            this.exibirMensagemErro(err)
          }
      })
    } else {
      this.loadingTable = false;
    }

  }

  definirOrdenacao(sortField?: string, sortOrder?: number) {
    const campoDeOrdenacao = sortField ? sortField : 'controleComanda';
    const direcaoOrdenacao = sortOrder === -1 ? 'DESC' : 'ASC';
    this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
  }

  buscar(event: Event) {
    this.loadingTable = true;
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.listarComandas();
  }

  limpar() {
    this.loadingTable = true;
    this.filter.nativeElement.value = '';
    this.inputBusca = '';
    this.listarComandas();
  }

  

  verificarEditar(status: string) {
    return status === 'ABERTA' || status === 'REABERTA';
  }

  abrirDialogSangriaListar() {
    this.messagemVisivelDialog = false;
    this.exibirDialogSangriaListar = true;
    if(this.caixaSelecionado) {
      this.listarSangrias();
    }
  }

  listarSangrias() {
    this.loadingSangriaListar = true;
    this.transferenciaContaService.listarSangriasCaixa(this.getEmpresa().id, this.caixaSelecionado?.dataCaixa).subscribe({
      next: (data: TransferenciaConta[]) => {
        this.listaSangrias = data;
        this.loadingSangriaListar = false;
      },
      error: (err: any) => {
        this.exibirDialogSangriaListar = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  abrirDialogSangriaInserir() {
    this.loadingSangria = false;
    this.exibirDialogSangria = true;
    this.carregarContasSangria();
  }

  carregarContasSangria() {
    this.tipoPagamentoService.listarTiposPagamentoOrigemCaixaPorEmpresa(this.getEmpresa().id).subscribe({
      next: (data: TipoPagamento[]) => {
        this.tiposPagamentoSangriaOrigem = data;
        if(data.length === 1) {
          this.tipoPagamentoOrigemSelecionado = data[0];
        }
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })

    this.tipoPagamentoService.listarTiposPagamentoDestinoCaixaPorEmpresa(this.getEmpresa().id).subscribe({
      next: (data: TipoPagamento[]) => {
        this.tiposPagamentoSangriaDestino = data;
        if(data.length === 1) {
          this.tipoPagamentoDestinoSelecionado = data[0];
        }
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  transferir() {
    this.loadingSangria = true;
    const transferenciaDto: TransferenciaConta = {
      tipoPagamentoOrigem: this.tipoPagamentoOrigemSelecionado,
      tipoPagamentoDestino: this.tipoPagamentoDestinoSelecionado,
      valorTransferido: this.valorSangria,
      data: this.caixaSelecionado?.dataCaixa,
      empresa: this.getEmpresa(),
      usuario: this.getUsuarioLogadoSistema()
    }
  
    this.transferenciaContaService.transferirSangria(transferenciaDto).subscribe({
      next: (data: TransferenciaConta) => {
        this.exibirDialogSangria = false;
        this.limparValoresDialogSangria();
        this.exibirMensagemSucessoDialog();
        this.listarSangrias();
      },
      error: (err: any) => {
        this.loadingSangria = false;
        this.exibirDialogSangria = false;
        this.exibirMensagemErroDialog(err);
      }
    })
  }

  excluirSangria(sangriaId?: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.transferenciaContaService.excluir(sangriaId).subscribe({
          next: () => {
            this.listarSangrias();
            this.exibirMensagemSucessoDialog();
          },
          error: (err: any) => {
            this.exibirDialogSangriaListar = false;
            this.exibirMensagemErroDialog(err);
          }
        })
      }
      });
  }

  limparValoresDialogSangria() {
    this.tipoPagamentoOrigemSelecionado = undefined;
    this.tipoPagamentoDestinoSelecionado = undefined;
    this.valorSangria = 0;
  }


  abrirDialogSaida() {
    this.messagemVisivelDialog = false;
    this.exibirDialogSaida = true;
    if(this.caixaSelecionado) {
      this.listarSaidasCaixa();
    }
  }

  listarSaidasCaixa() {
    this.loadingSaida = true;
    this.saidaCaixaService
      .listarPorEmpresaECaixa(this.getEmpresa().id,
        this.caixaSelecionado?.dataCaixa).subscribe({
          next: (data: SaidaCaixa[]) => {
            this.listaSaidasCaixa = data;
            this.loadingSaida = false;
          },
          error: (err: any) => {
            this.loadingSaida = false;
            this.exibirMensagemErro(err);
          }
        })
  }

  abrirDialogSaidaInserir() {
    this.exibirDialogSaidaInserir = true;
    this.carregarTiposPagamentoSaida(); 
  }

  carregarTiposPagamentoSaida() {
    this.tipoPagamentoService.listarTiposPagamentoOrigemCaixaPorEmpresa(this.getEmpresa().id)
      .subscribe({
        next: (data: TipoPagamento[]) => {
          this.listaTipoPagamentoSaida = data;
        },
        error: (err: any) => {
          this.exibirMensagemErro(err);
        }
      })
  }

  salvarSaida() {
    this.loadingSaidaInserir = true;
    const saidaCaixaReq: SaidaCaixa = {
      dataFluxo: this.caixaSelecionado?.dataCaixa,
      identificacao: this.identificacaoSaida,
      tipoPagamento: this.tipoPagamentoSaidaSelecionado,
      valorFluxo: this.valorSaida,
      empresaId: this.getEmpresa().id,
      operador: this.getUsuarioLogadoSistema().id
    }
    this.saidaCaixaService.salvar(saidaCaixaReq).subscribe({
      next: (data: SaidaCaixa) => {
        this.loadingSaidaInserir = false;
        this.exibirDialogSaidaInserir = false;
        this.listarSaidasCaixa();
        this.redefinirValoresSaida();
        this.exibirMensagemSucessoDialog();
      },
      error: (err: any) => {
        this.loadingSaidaInserir = false;
        this.exibirDialogSaidaInserir = false;
        this.exibirMensagemErroDialog(err);
      }
    })
  }

  excluirSaida(saidaId?: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja excluir?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.saidaCaixaService.excluir(saidaId).subscribe({
          next: () => {
            this.listarSaidasCaixa();
            this.exibirMensagemSucessoDialog();
          },
          error: (err: any) => {
            this.exibirMensagemErroDialog(err);
          }
        })
      }
      });
  }

  redefinirValoresSaida() {
    this.tipoPagamentoSaidaSelecionado = undefined;
    this.identificacaoSaida = '';
    this.valorSaida = undefined;
  }

  abrirDialogPagamentosListar() {
    this.messagemVisivelDialog = false;
    this.exibirDialogPagamentoListar = true;
    if(this.caixaSelecionado){
      this.listarPagamentosRealizados();
    }
  }

  listarPagamentosRealizados() {
    this.loadingPagamentosListar = true;
    this.pagamentoDespesaService.listarPagamentosEfetuadosPeloCaixa(this.getEmpresa().id, this.caixaSelecionado?.dataCaixa).subscribe({
      next: (data: PagamentoDespesa[]) => {
        this.listaDespesasPagas = data;
        this.loadingPagamentosListar = false;
      },
      error: (err: any) => { 
        this.loadingPagamentosListar = false;
        this.exibirDialogPagamentoListar = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  estornarDespesa(item: PagamentoDespesa){
    this.confirmationService.confirm({
          message: 'Estornar Pagamento?',
          header: 'Confirmação',
          acceptLabel: 'Sim',
          rejectLabel: 'Não',
          icon: 'pi pi-info-circle',
          accept: () => {
            this.loadingPagamentosListar = true;
            const pagamentoAtualizado: PagamentoDespesa = item;
            pagamentoAtualizado.dataFluxo = undefined;
            pagamentoAtualizado.operador = this.getUsuarioLogadoSistema().id;
            pagamentoAtualizado.status = 3;
            pagamentoAtualizado.tipoPagamento = undefined;
    
            this.pagamentoDespesaService.atualizar(pagamentoAtualizado, pagamentoAtualizado.id).subscribe({
              next: () => {
                this.listarPagamentosRealizados();
                this.exibirMensagemSucessoDialog();
              },
              error: (err: any) => {
                this.loadingPagamentosListar = false;
                this.exibirMensagemErroDialog(err);
              }
            });
          }
        });
  }


  abrirDialogPagamentosInserir() {
    this.etapaPagamento = false;
    this.despesaSelecionada = undefined;
    this.filtroMesSelecionado = undefined;
    this.exibirDialogPagamentos = true;
    if(this.caixaSelecionado) {
      this.listarCompetenciasVencimentoPagamento();
      this.carregarTiposPagamentoDespesa();
    }
  }

  listarCompetenciasVencimentoPagamento() {
    this.pagamentoDespesaService.listarCompetenciasComPagamentosEmAberto(this.getEmpresa().id)
      .subscribe({
        next: (data: CompetenciaDTO[]) => {
          this.filtroMesesPagamentos = data.map(comp => (
            {label: comp.descricao, value: comp})
          );
          this.filtroMesSelecionado = data[0];
          this.listarPagamentosDespesa();
        },
        error: (err: any) => {
          this.exibirDialogPagamentos = false;
          this.exibirMensagemErroDialog(err);
        }
      })
  }

  carregarTiposPagamentoDespesa() {
    this.tipoPagamentoService.listarTiposPagamentoOrigemCaixaPorEmpresa(this.getEmpresa().id)
      .subscribe({
        next: (data: TipoPagamento[]) => {
          this.listaTipoPagamentoDespesa = data;
        },
        error: (err: any) => {
          this.exibirMensagemErroDialog(err);
        }
      })
  }

  listarPagamentosDespesa() {
    this.loadingPagamentos = true;
    this.pagamentoDespesaService
      .listarAPagarPorEmpresaIdECompetenciaVencimento(this.getEmpresa().id, this.filtroMesSelecionado?.mes, this.filtroMesSelecionado?.ano)
      .subscribe({
        next: (data: PagamentoDespesa[]) => {
          this.listaDespesasEmAberto = data;
          this.loadingPagamentos = false;

        },
        error: (err: any) => {
          this.loadingPagamentos = false;
          this.exibirMensagemErroDialog(err);
        }
      })
  }

  selecionarDespesa(despesa: PagamentoDespesa) {
    this.etapaPagamento = true;
    this.despesaSelecionada = despesa;
  }

  pagarDespesa() {
    if(this.despesaSelecionada){
      this.progressoRequisicaoPagamento = true;
      this.despesaSelecionada.tipoPagamento = this.tipoPagamentoDespesaSelecionado;
      this.despesaSelecionada.dataFluxo = this.caixaSelecionado?.dataCaixa;
      this.despesaSelecionada.operador = this.getUsuarioLogadoSistema().id;

      this.pagamentoDespesaService.pagarDespesaCaixa(this.despesaSelecionada).subscribe({
        next: (data: PagamentoDespesa) => {
          this.progressoRequisicaoPagamento = false;
          this.exibirDialogPagamentos = false;
          this.abrirDialogPagamentosListar();
          this.exibirMensagemSucessoDialog();
        },
        error: (err: any) => {
          this.progressoRequisicaoPagamento = false;
          this.exibirDialogPagamentos = false;
          this.exibirMensagemErroDialog(err);
        }
      })
    }
  }

}
